export enum BulkChangeBillingForms {
  Preview = 'PreviewBulkChangeBilling',
  Create = 'CreateBulkChangeBilling',
}
